import SHA256 from 'crypto-js/sha256';

export const pseudoanonymizeEmail = (email: string) => {
    if (!email || email.trim() === '') return '';

    const [local, domain] = email.split('@');
    if (!local || !domain) return '';

    const localHashed = SHA256(local).toString();
    const domainShort = `${domain.slice(0, 2)}...${domain.slice(-2)}`;
    return `${localHashed}@${domainShort}`;
};
